import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { useConfigTypeTitle } from '@eggplant/routing'

const ScriptedGlobalParamsDescription = () => {
  const configTypeText = useConfigTypeTitle()

  return (
    <Paragraph>
      <Color variant='theme-description-text'>
        Global parameter are shared across all test cases within a script-based {configTypeText}s config. Once they are defined you can then use them as your custom parameter values.
      </Color>
    </Paragraph>
  )
}

export default ScriptedGlobalParamsDescription
